export default "__VITE_ASSET__BVSRFFpM__"